'use strict';
const angular = require('angular');

/*@ngInject*/
export function ReservationService($resource) {
  return $resource('/api/reservations/:id', {
    id: '@_id'
  },{
    getByTypeAndState: {
      method: 'GET',
      url: "/api/reservations/type/:type/state/:state",
      isArray: true
    },
    getUpcomingByUserAndType: {
      method: 'GET',
      url: "/api/reservations/type/:type/user/:userId/upcoming",
      isArray: true
    },
    getPastByUserAndType: {
      method: 'GET',
      url: "/api/reservations/type/:type/user/:userId/past",
      isArray: true
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.ReservationService', [])
  .factory('ReservationService', ReservationService)
  .name;



// WEBPACK FOOTER //
// ./client/services/reservation/reservation.service.js